"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrMediaItem = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const fdr_regular_basis_fdr_route_1 = require("@hotelplan/fdr.regular.basis.fdr-route");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const FdrMediaItemWrapper = styled_components_1.default.div((0, util_theme_sxc_1.sx2CssThemeFn)({
    position: 'relative',
    justifyContent: 'center',
    textAlign: 'center',
    height: '100%',
    width: '100%',
    borderRadius: 'default',
    overflow: 'hidden',
    ':before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundImage: 'linear-gradient(-180deg, rgba(0, 0, 0, 0) 45%, rgba(0, 0, 0, 0.6) 100%)',
        zIndex: '1',
    },
    img: {
        width: '100%',
        height: '100%',
        objectFit: `cover`,
    },
}));
const FdrMediaItemLink = FdrMediaItemWrapper.withComponent(fdr_regular_basis_fdr_route_1.FdrRoute);
const FdrMediaItem = ({ testId, link, onClick, children, className, }) => {
    const wrapperProps = { className, onClick, children, 'data-id': testId };
    return link ? (react_1.default.createElement(FdrMediaItemLink, Object.assign({ link: link }, wrapperProps))) : (react_1.default.createElement(FdrMediaItemWrapper, Object.assign({}, wrapperProps)));
};
exports.FdrMediaItem = FdrMediaItem;
//# sourceMappingURL=index.js.map